import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'

import totalData from './views/issue/totalData.vue'
import totalDataDetail from './views/issue/totalDataDetail.vue'
import totalDetail from './views/issue/totalDetail.vue'
import basicData from './views/issue/basicData.vue'
import basicDetail from './views/issue/basicDetail.vue'
import channelControl from './views/issue/channelControl.vue'
import channelData from './views/issue/channelData.vue'
import pList from './views/issue/pList.vue'

import channelDataList from './views/issue/channelDataList.vue'

import channelDataListDetail from './views/issue/channelDataListDetail.vue'

import gdtDataList from './views/issue/gdtDataList.vue';

import pythonList from './views/python/list'

import productDaily from './views/daily/productDaily'
import productDailyDetail from './views/daily/productDailyDetail'

import incomeDaily from './views/income/incomeDaily'
import incomeDailyDetail from './views/income/incomeDailyDetail'

import costDaily from './views/income/costDaily'

import costDailyDetail from './views/income/costDailyDetail'

import billDataList from './views/income/dataList'

import billDataDetail from './views/income/dataDetail'

import CPDataList from './views/cp/dataList'

import CPDataDetail from './views/cp/dataDetail'

import CPStatistics from './views/cp/statisticsList'

import CPStatisticsDetail from './views/cp/statisticsDetail'

import exchangeDaily from './views/exchange/exchangeDaily'

import exchangeDailyDetail from './views/exchange/exchangeDailyDetail'


import costLogList from './views/log/costLog'

import dataBoard from './views/issue/dataBoard.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '登录',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '404',
        hidden: true
    },
    {
    	path:'http://beta-sdk-api.y7y.net/index.php?s=/platform',
    	component: NotFound,
        name: 'out',
        hidden: true
    },
    {
        path: '/',
        leaf:true,
        component: Home,
        redirect:'/mainData/index',
        name: '整体数据',
        iconCls: 'el-icon-message',//图标样式class
        children: [
        	{ path: 'dataBoard/index', component: dataBoard, name: '数据汇总' },    	
            { path: 'mainData/index', component: totalData, name: '整体数据2' },
            { path: 'mainData/index/:issued_app_id', component: totalDataDetail, name: '整体数据详情' },
            { path: '/totalDetail/:issued_app_id', component: totalDetail, name: '更多数据' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '基础数据',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: 'baseData/index', component: basicData, name: '基础数据2' },
            { path: '/basicDetail', component: basicDetail, name: '基础更多' },
            { path: 'productDaily/index', component: productDaily, name: '产品日报',meta:{keepAlive:true}},
            { path: 'productDaily/detail/:issued_app_id', component: productDailyDetail, name: '产品日报详情',meta:{keepAlive:true} },
            { path: 'incomeDaily/index', component: incomeDaily, name: '收入日报' ,meta:{keepAlive:true}},
            { path: 'incomeDaily/detail', component: incomeDailyDetail, name: '收入日报详情',meta:{keepAlive:true}},
            {path:'costDaily/index', component: costDaily, name: '成本日报'},
            {path:'costDaily/index/:issued_app_id', component: costDailyDetail, name: '成本日报详情'},
            {path:'exchange/index', component: exchangeDaily, name: '扣量日报'},
            {path:'exchange/detail/:company_id', component: exchangeDailyDetail, name: '扣量日报详情'},
            
            
        ]
    },
    {
        path: '/',
        component: Home,
        name: '成本账单',
        iconCls: 'el-icon-message',//图标样式class
        children: [
        	{ path: 'billIssuedData/index', component: billDataList, name: '账单列表' },
        	{ path: 'billData/detail/:index_id', component: billDataDetail, name: '账单详情明细' },
        	
        ]
    },
    {
        path: '/',
        component: Home,
        name: '分成账单',
        iconCls: 'el-icon-message',//图标样式class
        children: [
        	{ path: 'billCpData/index', component: CPDataList, name: '账单列表' },
        	{ path: 'billCpData/detail/:index_id', component: CPDataDetail, name: '账单详情明细' },
        	{ path: 'billCpData/summary', component: CPStatistics, name: '分成账单统计' },
        	{ path: 'billCpData/summary/:id', component: CPStatisticsDetail, name: '分成账单统计详情' },
        	
        	
        	
        ]
    },
    {
        path: '/',
        component: Home,
        name: '渠道数据',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: 'issuedAldChannel/index', component: channelControl, name: '渠道管理', },
            { path: 'issuedAldData/index', component: channelData, name: '渠道分析' },
            { path: 'issuedAldData/list/:issued_app_id', component: channelDataList, name: '渠道数据分析列表'},
            { path: 'issuedAldData/list/detail/:issued_app_id', component: channelDataListDetail, name: '渠道数据分析列表详情'},
            { path: 'issuedAldChannelGdt/index', component: gdtDataList, name: '广点通渠道回收'},
        ]
    },
    
    {
        path: '/',
        component: Home,
        leaf:true,
        name: '账号管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: 'issuedApp/index', component: pList, name: '账号管理2'},
        ]
    },
    {
       path: '/',
       component: Home,
       name: '脚本列表',
       iconCls: 'el-icon-message',//图标样式class
       children: [
           { path: '/python/index', component: pythonList, name: '脚本列表2' },
       ],
       redirect: { name: '404' }
    },
     {
       path: '/',
       component: Home,
       name: '日志管理',
       iconCls: 'el-icon-message',//图标样式class
       children: [
           { path: '/log/cost', component: costLogList, name: '成本日志' },
       ],
       redirect: { name: '404' }
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js